import { addDays } from "date-fns";

const today = Date.now();
addDay(today, 10);
